var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navBar"},[(_vm.show)?_c('van-icon',{attrs:{"name":"arrow-left","size":"22","color":"#333333"},on:{"click":_vm.back}}):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }